import { Theme } from '@mui/material';

export default {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => ({
			height: 'auto',
			padding: '0px',
			color: `${theme.palette.primary.main} !important`,
		}),
	},
};
